import { motion, useTransform, useScroll } from "framer-motion";
import { FaArrowUp } from "react-icons/fa";

const ScrollToTopButton = ({ isBackgroundWhite }) => {
  const { scrollY } = useScroll();
  const y = useTransform(scrollY, [0, 200], [100, 0]);
  const opacity = useTransform(scrollY, [0, 200], [0, 1]);

  const handleClick = () => {
    const introElement = document.querySelector("#intro");
    introElement.scrollIntoView({ behavior: "smooth", block: "start", top: 0 });
  };

  return (
    <motion.button
      className={"fixed bottom-0 left-0 mb-8 ml-32 p-2 rounded-full shadow-lg" + (isBackgroundWhite ? "bg-white text-black" : "bg-black text-white")}
      style={{ y, opacity, scale: 2, zIndex: 40 }}
      onClick={handleClick}
    >
      <FaArrowUp className="inline" /> remonter
    </motion.button>
  );
};

export default ScrollToTopButton;
